import krea from '../assets/krea.png';
import gainea from '../assets/gainea.png';
import babeelashes from '../assets/babeelashes.png';
import moviz2 from '../assets/moviz2.png';

export const projects = [
  {
    img: krea,
    title: 'Krea',
    category: 'E-commerce',
    url: 'https://kreastore.be',
  },
  {
    img: gainea,
    title: 'Gainea',
    category: 'E-commerce',
    url: 'https://gainea.be',
  },
  {
    img: babeelashes,
    title: 'Babeelashes',
    category: 'Web Development',
    url: 'https://www.babeelashes.be',
  },
  {
    img: moviz2,
    title: 'My Moviz 2.0',
    category: 'Web Development',
    url: 'https://movie-tau-mocha.vercel.app/',
  },

];
